import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { SearchableSelect } from '@/components/ui/searchable-select';
import { Minus, Plus, X } from 'lucide-react';

// Editor da composição padrão de um tipo de caixa (kit padrão)
export function KitPadraoEditor({ composicao = [], onChange, materiaisOptions, getMaterialNome }) {
  const [selKey, setSelKey] = useState(0);

  const add = (materialId) => {
    if (!materialId) return;
    const exists = composicao.find(c => c.material_id === materialId);
    onChange(exists
      ? composicao.map(c => c.material_id === materialId ? { ...c, quantidade: c.quantidade + 1 } : c)
      : [...composicao, { material_id: materialId, quantidade: 1 }]);
    setSelKey(k => k + 1);
  };
  const setQ = (id, q) => onChange(q <= 0 ? composicao.filter(c => c.material_id !== id) : composicao.map(c => c.material_id === id ? { ...c, quantidade: q } : c));

  return (
    <div data-testid="kit-padrao-editor">
      <Label>Kit padrão (peças que vêm preenchidas na montagem)</Label>
      <div className="mt-1" key={selKey}>
        <SearchableSelect options={materiaisOptions} value="" onChange={add} placeholder="Adicionar material ao kit..." searchPlaceholder="Buscar material..." data-testid="select-kit-padrao-material" />
      </div>
      {composicao.length === 0 ? (
        <p className="text-xs text-slate-400 mt-2">Sem kit padrão: a caixa começa vazia na montagem.</p>
      ) : (
        <div className="mt-2 border rounded-lg divide-y">
          {composicao.map(c => (
            <div key={c.material_id} className="flex items-center justify-between px-3 py-1.5" data-testid={`kit-padrao-item-${c.material_id}`}>
              <span className="text-sm text-slate-800 truncate">{getMaterialNome(c.material_id)}</span>
              <div className="flex items-center gap-1 shrink-0">
                <Button type="button" variant="outline" size="sm" className="h-7 w-7 p-0" onClick={() => setQ(c.material_id, c.quantidade - 1)}><Minus className="w-3.5 h-3.5" /></Button>
                <input type="number" min="1" value={c.quantidade} onFocus={e => e.target.select()} onChange={e => setQ(c.material_id, Math.max(1, parseInt(e.target.value) || 1))} className="w-12 h-7 text-center text-sm border rounded" data-testid={`kit-padrao-qtd-${c.material_id}`} />
                <Button type="button" variant="outline" size="sm" className="h-7 w-7 p-0" onClick={() => setQ(c.material_id, c.quantidade + 1)}><Plus className="w-3.5 h-3.5" /></Button>
                <Button type="button" variant="ghost" size="sm" className="h-7 w-7 p-0 text-red-500" onClick={() => setQ(c.material_id, 0)}><X className="w-3.5 h-3.5" /></Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
